import { Component, effect, inject, OnInit, NgZone } from '@angular/core';
import { SharedSignalsService } from '../common/services/shared-signals.service';
import { Item } from '../common/models/faq.model';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

interface SecurityTip {
  icon: string;
  key: string;
}

@Component({
  selector: 'taly-customer-complaints',
  templateUrl: './customer-complaints.component.html',
  styleUrl: './customer-complaints.component.scss',
  standalone: false,
})
export class CustomerComplaintsComponent implements OnInit {
  transferSignal = inject(SharedSignalsService);
  ngZone = inject(NgZone);
  textDirection: string;

  cbkSteps = [
    'CUSTOMER_COMPLAINTS.COMPLAINT_REASON_1',
    'CUSTOMER_COMPLAINTS.COMPLAINT_REASON_2',
    'CUSTOMER_COMPLAINTS.COMPLAINT_REASON_3',
  ];

  methodItems = [
    'CUSTOMER_COMPLAINTS.COMPLAINTS_METHODS_1',
    'CUSTOMER_COMPLAINTS.COMPLAINTS_METHODS_2',
    'CUSTOMER_COMPLAINTS.COMPLAINTS_METHODS_3',
    'CUSTOMER_COMPLAINTS.COMPLAINTS_METHODS_4',
  ];

  remarkItems = [
    'CUSTOMER_COMPLAINTS.REMARKS_1',
    'CUSTOMER_COMPLAINTS.REMARKS_2',
    'CUSTOMER_COMPLAINTS.REMARKS_3',
    'CUSTOMER_COMPLAINTS.REMARKS_4',
    'CUSTOMER_COMPLAINTS.REMARKS_5',
  ];

  securityTips: SecurityTip[] = [
    { icon: 'assets/images/s-sources.svg', key: 'CUSTOMER_COMPLAINTS.REMARKS_6' },
    { icon: 'assets/images/s-link.svg', key: 'CUSTOMER_COMPLAINTS.REMARKS_7' },
    { icon: 'assets/images/s-number.svg', key: 'CUSTOMER_COMPLAINTS.REMARKS_8' },
  ];

  faqItems: Item[] = [
    { id: 1, position: 1, itemTitleEn: 'Lorem ipsum dolor sit amet consectetur.', itemTitleAr: 'Lorem ipsum dolor sit amet consectetur.', descriptionEn: 'Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', descriptionAr: 'Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' },
    { id: 2, position: 2, itemTitleEn: 'Lorem ipsum dolor sit amet consectetur.', itemTitleAr: 'Lorem ipsum dolor sit amet consectetur.', descriptionEn: 'Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', descriptionAr: 'Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' },
    { id: 3, position: 3, itemTitleEn: 'Lorem ipsum dolor sit amet consectetur.', itemTitleAr: 'Lorem ipsum dolor sit amet consectetur.', descriptionEn: 'Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', descriptionAr: 'Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' },
    { id: 4, position: 4, itemTitleEn: 'Lorem ipsum dolor sit amet consectetur.', itemTitleAr: 'Lorem ipsum dolor sit amet consectetur.', descriptionEn: 'Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', descriptionAr: 'Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' },
    { id: 5, position: 5, itemTitleEn: 'Lorem ipsum dolor sit amet consectetur.', itemTitleAr: 'Lorem ipsum dolor sit amet consectetur.', descriptionEn: 'Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', descriptionAr: 'Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' },
  ];

  constructor() {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
    });
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  downloadPdf(): void {
    this.ngZone.runOutsideAngular(() => {
      const iframe = document.createElement('iframe');
      iframe.style.position = 'absolute';
      iframe.style.left = '-9999px';
      iframe.style.top = '-9999px';
      iframe.style.width = '1086px';
      iframe.style.height = '1537px';
      iframe.style.border = 'none';
      iframe.src = 'assets/docs/customer-complaints-form.html';

      iframe.onload = () => {
        const doc = iframe.contentDocument;
        const win = iframe.contentWindow as any;
        if (!doc || !win) return;

        const element = doc.querySelector('.page') as HTMLElement;
        if (!element) return;
        const waitForFonts = win.document.fonts ? win.document.fonts.ready : Promise.resolve();

        waitForFonts.then(() => {
          setTimeout(async () => {
            try {
              const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                logging: false,
                window: win
              } as any);

              const imgData = canvas.toDataURL('image/jpeg', 0.98);

              const pdf = new jsPDF({
                unit: 'pt',
                format: 'a4',
                orientation: 'portrait',
                compress: true
              });

              const pdfWidth = pdf.internal.pageSize.getWidth();
              const pdfHeight = (1537 * pdfWidth) / 1086;

              pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST');

              pdf.save('Customer_Complaints_Form.pdf');

            } catch (error) {
              console.error('Error generating PDF:', error);
            } finally {
              document.body.removeChild(iframe);
            }
          }, 100); // reduced from 1000ms to 100ms
        });
      };

      document.body.appendChild(iframe);
    });
  }
}

